import actions from './actions'
import {nextState, upload, uploadPrepare} from '../helper'

let initState = {
	single: {},
	filmography: [],
	loading: false,
	total: 0,
	params: {
		query: '',
		limit: 50,
		skip: 0,
	},
	data: []
}

export default function filmReducer(state = initState, action) {

	const {type, payload} = action

	switch (type) {

		case actions.LOAD_PERSON_FILMOGRAPHY_SUCCESS:
			return {
				...state,
				filmography: payload
			}

		case actions.LOAD_PERSON_SUCCESS:
			return {
				...state,
				single: payload
			}

		case actions.CHANGE_PERSON:
			return nextState({
				...state,
				single: {
					...state.single,
					...payload
				}
			})

		case actions.RESET_PERSON:
			return {
				...state,
				single: {},
				filmography: []
			}



		case actions.SEARCH_PERSON_PARAMS:
			return {
				...state,
				params: {
					...state.params,
					...payload
				}
			}

		case actions.SEARCH_PERSON_SUCCESS:
			return {
				...state,
				total: payload.total,
				data: payload.data
			}



		case actions.UPLOAD_PERSON:
			return nextState({
				...state,
				single: uploadPrepare(state.single, payload)
			})

		case actions.UPLOAD_PERSON_SUCCESS:
			return nextState({
				...state,
				single: upload(state.single, payload)
			})

		case actions.REMOVE_PERSON:
			return {
				...state,
				data: state.data.filter(rec => rec._id !== payload)
			}

		default:
			return state
	}
}
